import React from 'react';
import './SubNav.css';

export const SubNav = ({ tabs, activeTab, onTabClicked }) => {
  return (
    <div className="sub-nav">
      {tabs.map((tab, index) => (
        <button
          key={index}
          className={`sub-nav-pill ${activeTab === index ? 'active' : ''}`}
          onClick={() => onTabClicked(index)}
        >
          {tab}
        </button>
      ))}
    </div>
  );
};

export default SubNav;
